var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRainClouds(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 120,
    height: 120,
    viewBox: "0 0 120 120",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.3351 105.5C16.8777 104.62 31.4832 75 31.4832 75M41.1775 105.5C41.7201 104.62 56.3255 75 56.3255 75M65.7081 105.5C66.2507 104.62 80.8561 75 80.8561 75",
    stroke: "#51C2F0",
    strokeWidth: 8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "path-3-outside-1",
    maskUnits: "userSpaceOnUse",
    x: -1,
    y: 3,
    width: 112,
    height: 68,
    fill: "black"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "white",
    x: -1,
    y: 3,
    width: 112,
    height: 68
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.6001 31C34.3797 17.3066 46.4863 7 61 7C75.533 7 87.6524 17.3339 90.4109 31.0545C99.6926 31.7741 107 39.5337 107 49C107 58.9411 98.9411 67 89 67H21C11.0589 67 3 58.9411 3 49C3 39.0589 11.0589 31 21 31H31.6001Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M31.6001 31C34.3797 17.3066 46.4863 7 61 7C75.533 7 87.6524 17.3339 90.4109 31.0545C99.6926 31.7741 107 39.5337 107 49C107 58.9411 98.9411 67 89 67H21C11.0589 67 3 58.9411 3 49C3 39.0589 11.0589 31 21 31H31.6001Z",
    fill: "#AAAAAA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.6001 31C34.3797 17.3066 46.4863 7 61 7C75.533 7 87.6524 17.3339 90.4109 31.0545C99.6926 31.7741 107 39.5337 107 49C107 58.9411 98.9411 67 89 67H21C11.0589 67 3 58.9411 3 49C3 39.0589 11.0589 31 21 31H31.6001Z",
    stroke: "white",
    strokeWidth: 8,
    mask: "url(#path-3-outside-1)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 120,
    height: 120,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRainClouds);
export default __webpack_public_path__ + "static/media/rain_clouds.82e4d0eba38770c54e43d738c14f2a37.svg";
export { ForwardRef as ReactComponent };